module.exports = __webpack_public_path__ + "02450708877e0d1da2606fbe8e292d6a.svg";